export default "__VITE_ASSET__CxN44ETG__"